import type { HolidaysType } from './holidays-type';
import { _holidaysForStaffingCalendar } from './_holidays-for-staffing-calendar';

export const holidaysForStaffingCalendar = (): HolidaysType => _holidaysForStaffingCalendar;
